var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BaseFrame from "../BaseFrame";
var ErrorPage = function (_a) {
    var title = _a.title, appName = _a.appName, errorText = _a.errorText, links = _a.links;
    return (_jsx(BaseFrame, __assign({ title: title, appName: appName }, { children: _jsx("div", __assign({ className: "min-h-screen w-screen flex justify-center items-center" }, { children: _jsxs("div", __assign({ className: "flex flex-col justify-center items-center" }, { children: [_jsx("h1", __assign({ className: "text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight" }, { children: errorText })), _jsx("div", __assign({ className: "mt-6 flex gap-3" }, { children: links.map(function (l) { return _jsx("a", __assign({ href: l.href }, { children: l.text })); }) }))] })) })) })));
};
export default ErrorPage;
